import React from 'react';

import { ISVGPersonalProps } from 'types/svg';

export const arrowDown: ISVGPersonalProps = {
  viewBox: '0 0 10.033 5',
  content: <path d="M5.016 0 0 .003 2.506 2.5 5.016 5l2.509-2.5L10.033.003 5.016 0z" />,
};
